import { render, staticRenderFns } from "./scholarship.vue?vue&type=template&id=77010184&scoped=true&"
import script from "./scholarship.vue?vue&type=script&lang=js&"
export * from "./scholarship.vue?vue&type=script&lang=js&"
import style0 from "./scholarship.vue?vue&type=style&index=0&id=77010184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77010184",
  null
  
)

export default component.exports